import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { messages } from './messages';
import style from './styles.module.less';
import { useScanVerificationContext } from '../../scan-verification-context-provider';

import type { CellProps } from './types';

const ScannedCell = ({ row }: CellProps) => {
  const { getVerifiedCount } = useScanVerificationContext();
  const item = row.original;

  return `${getVerifiedCount(item.fulfillmentPlanItemId)} / ${item.quantity}`;
};

export const createScannedColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'scanned',
  Header: <FormattedMessage {...messages.scannedColumnHeader} />,
  Cell: ScannedCell,
  className: style['centered-cell'],
});
